import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { DataTable } from 'react-native-paper';
import PropTypes from 'prop-types';

function WaterUseDataTableHeader({ pageContent }) {
  return (
    <DataTable.Header style={styles.header}>
      {pageContent.map((content, index) => (
        <DataTable.Title
          key={`title-${index}`}
          numberOfLines={2}
          style={styles.title}
        >
          <Text style={styles.titleText} numberOfLines={2}>
            {content}
          </Text>
        </DataTable.Title>
      ))}
    </DataTable.Header>
  );
}

const styles = StyleSheet.create({
  header: {
    minHeight: 40,
  },
  titleText: {
    lineHeight: 16,
    overflow: 'visible',
  },
});

WaterUseDataTableHeader.propTypes = {
  pageContent: PropTypes.arrayOf(PropTypes.string),
};

export default WaterUseDataTableHeader;
